import React, { useState, useEffect, useRef } from 'react';
import { useSelectedLocation } from '../../hooks';
import ActionPlanDashboard from './pages/ActionPlanDashboard';
import CreateNewActionPlan from './pages/CreateNewActionPlan';
import ActionPlanDetails from './pages/ActionPlanDetails';

interface ActionPlanProps {
  initialRoute?: string;
  actionPlanId?: string;
  onBackPress: () => void;
}

const ActionPlan: React.FC<ActionPlanProps> = ({
  initialRoute = 'ActionPlanDashboard',
  actionPlanId,
  onBackPress,
}) => {
  const [currentRoute, setCurrentRoute] = useState(initialRoute);
  const [selectedActionPlanId, setSelectedActionPlanId] = useState<string | undefined>(
    actionPlanId
  );

  // Safe ref pattern: redirect to ActionPlanDashboard on location change
  const selectedLocation = useSelectedLocation();
  const prevLocationIdRef = useRef<string | undefined>(selectedLocation?.id);
  useEffect(() => {
    const prevId = prevLocationIdRef.current;
    prevLocationIdRef.current = selectedLocation?.id;
    if (prevId && selectedLocation?.id && prevId !== selectedLocation.id && currentRoute !== 'ActionPlanDashboard') {
      setCurrentRoute('ActionPlanDashboard');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLocation?.id, currentRoute]);

  useEffect(() => {
    if (initialRoute === 'ActionPlanDashboard') {
      setCurrentRoute('ActionPlanDashboard');
    }
  }, [initialRoute]);

  // const handleNavigate = (route: string, params?: { [key: string]: any }) => {
  //   if (params?.actionPlanId) {
  //     setSelectedActionPlanId(params.actionPlanId);
  //   }
  //   setCurrentRoute(route);
  // };

  const handleBack = () => {
    if (currentRoute === 'ActionPlanDashboard') {
      onBackPress();
    } else {
      setCurrentRoute('ActionPlanDashboard');
    }
  };

  const handleCreateNewActionPlan = () => {
    setCurrentRoute('CreateNewActionPlan');
  };

  const renderScreen = () => {
    switch (currentRoute) {
      case 'ActionPlanDashboard':
        return (
          <ActionPlanDashboard
            onBackPress={handleBack}
            onCreateNewActionPlan={handleCreateNewActionPlan}
          />
        );
      case 'CreateNewActionPlan':
        return (
          <CreateNewActionPlan
            onCreated={(created: any) => {
              const id = created?.data?.actionPlanId ?? created?.actionPlanId ?? null;
              if (id) {
                setSelectedActionPlanId(String(id));
              }
              setCurrentRoute('ActionPlanDashboard');
            }}
            onCancel={() => {
              setCurrentRoute('ActionPlanDashboard');
            }}
          />
        );
      case 'ActionPlanDetails':
        return (
          <ActionPlanDetails
            onBackPress={handleBack}
            actionPlanId={selectedActionPlanId}
          />
        );
      default:
        return (
          <ActionPlanDashboard
            onBackPress={handleBack}
            onCreateNewActionPlan={handleCreateNewActionPlan}
          />
        );
    }
  };

  return renderScreen();
};

export default ActionPlan;
